const TableContainer = (props) => {
  const { children, className = '' } = props;

  return <table className={`w-full ${className}`}>{children}</table>;
};

export default TableContainer;
